var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.41681 9.66671C4.25154 9.66671 4.113 9.6108 4.00119 9.499C3.88938 9.38719 3.83348 9.24865 3.83348 9.08337V5.58337L0.450149 1.26671C0.304315 1.07226 0.28244 0.868096 0.384524 0.654207C0.486607 0.440318 0.664038 0.333374 0.916815 0.333374H9.08348C9.33626 0.333374 9.51369 0.440318 9.61577 0.654207C9.71786 0.868096 9.69598 1.07226 9.55015 1.26671L6.16681 5.58337V9.08337C6.16681 9.24865 6.11091 9.38719 5.99911 9.499C5.8873 9.6108 5.74876 9.66671 5.58348 9.66671H4.41681ZM5.00015 5.17504L7.88765 1.50004H2.11265L5.00015 5.17504Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterAlt);
export default __webpack_public_path__ + "static/media/filter_alt.7f5269c7bbe59e6ffe06062c209be3eb.svg";
export { ForwardRef as ReactComponent };